import { TasksView } from "@/components/organizer/TasksView";

const TasksPage = () => {
  return <TasksView />;
};

export { TasksPage };
